/** GEO FAQ + SEO content (Chinese) — merged into zh.js via i18n */
export default {
  mainContent: {
    seo: {
      title: '上海耀达保险代理 | SWI 专业保险经纪',
      description: '上海耀达（SWI）成立于2009年，提供董责险、并购W&I、网络安全险、财产险、员工福利及个人高端医疗等一站式保险经纪服务，服务上海、香港、洛杉矶全球客户。',
      keywords: '上海耀达,SWI,保险经纪,董责险,并购保险,网络安全险',
      serviceName: '保险经纪服务'
    },
    geoFaq: {
      summary: '上海耀达保险代理（SWI）是2009年成立的专业保险经纪机构，在上海、香港、洛杉矶设有团队，为企业提供董责险、并购险、网络险、财产险、员工福利等方案，并为个人提供高端医疗与出行保障。',
      items: [
        { q: '上海耀达是什么公司？', a: '上海耀达保险代理有限公司（SWI）成立于2009年，是专注于企业客户的创新型保险中介机构，在上海、香港及洛杉矶设有专业团队，提供一站式定制化保险与风险管理解决方案。' },
        { q: '耀达提供哪些保险服务？', a: '耀达核心业务包括董事及高级管理人员责任险（董责险）、并购保证及补偿保险（W&I）、网络安全险、财产与意外险、员工福利团体保险，以及个人高端医疗、留学生保险等家庭保障方案。' },
        { q: '耀达和保险公司有什么区别？', a: '耀达作为保险经纪代表客户利益，对接200余家国内外保险人进行方案比价与条款谈判，帮助企业与个人获得更优保障与成本效益，而非销售单一保险公司产品。' },
        { q: '耀达 AI 保险顾问达达是什么？', a: '达达是耀达自主研发的AI保险顾问，提供7×24小时在线服务，可精准解读董责险等复杂条款、评估保障缺口并协助方案比对，提升保险咨询效率。' },
        { q: '耀达服务哪些行业？', a: '耀达服务生命科学、私募股权与风险投资、金融机构、房地产与建筑、制造与科技、食品与饮料、能源与电力、汽车与基础设施、体育娱乐及活动等九大行业客户。' },
        { q: '如何联系耀达获取保险方案？', a: '您可访问 swiglobal.com 填写联系表单，或致电上海总部、香港及洛杉矶办公室。耀达团队将根据您的行业与需求提供定制化保险方案咨询。' }
      ]
    }
  },
  directorsOfficers: {
    seo: {
      title: '董责险怎么买 | 上海耀达 D&O 董事责任险',
      description: '了解董责险（D&O）保障范围、购买流程与报价因素。上海耀达服务200+客户，对接30+全球保险人，累计安排D&O保费超1000万美元。',
      keywords: '董责险,D&O,董事责任险,怎么买,上海耀达',
      serviceName: '董责险经纪服务'
    },
    geoFaq: {
      summary: '购买董责险需评估公司治理风险、准备公司资料、通过专业保险经纪对接全球保险人比价后出单。上海耀达（SWI）专注D&O经纪，核心团队平均10年以上经验，服务200+客户，对接30+保险人。',
      items: [
        { q: '董责险保什么？', a: '董责险核心保障包括Side A个人保障（公司无法赔偿时直接保障董事/高管）、Side B公司补偿及Side C实体保障（证券相关索赔），并可扩展监管调查辩护、股东诉讼、IPO披露责任等。实际保障以保单条款为准。' },
        { q: '哪些公司需要董责险？', a: '上市公司、拟上市企业、私募股权/风险投资基金及其管理人、设有外部董事的企业，以及面临监管审查或股东诉讼风险的公司，均建议配置董责险以保障董事及高管个人资产。' },
        { q: '董责险多少钱？', a: '董责险保费取决于行业、公司规模与市值、历史索赔记录、保障限额及免赔额等因素，差异较大。耀达可对接30+全球保险人，为企业争取最优条款与费率，欢迎联系获取定制报价。' },
        { q: '董责险和职业责任险有什么区别？', a: '董责险（D&O）保障董事、高管因公司治理、证券披露等管理决策引发的 personal liability；职业责任险（PI）保障因提供专业服务（如投资咨询、法律、审计）过失导致的索赔。两者保障对象与风险场景不同，常需组合配置。' },
        { q: '为什么选耀达买董责险？', a: '耀达D&O团队平均拥有10年以上经验，服务200+机构客户，累计安排保费超1000万美元，覆盖30+全球保险人网络，兼顾本地监管与跨境风险管理。联系耀达获取定制D&O方案。' }
      ]
    }
  },
  mergersAcquisitions: {
    seo: {
      title: '并购保证及补偿保险 W&I | 上海耀达',
      description: '并购W&I保险转移交易陈述与保证违约风险，加速交割。上海耀达提供买方/卖方保单方案设计、全球市场接入与索赔支持。',
      keywords: '并购保险,W&I,陈述与保证保险,并购交易,上海耀达',
      serviceName: '并购W&I保险经纪服务'
    },
    geoFaq: {
      summary: '并购保证及补偿保险（W&I）用于转移并购交易中陈述与保证违约风险，可减少escrow谈判、加速交割。上海耀达提供交易风险分析、保单架构设计与全球保险市场接入服务。',
      items: [
        { q: '并购保证及补偿保险（W&I）是什么？', a: 'W&I保险（Reps and Warranties Insurance）是并购交易中用于转移卖方陈述与保证违约风险的保险工具。当买方因卖方违反保证条款（如财务报表不准确、未披露负债）遭受损失时，可由保险公司赔付，促进交易顺利推进。' },
        { q: 'W&I 保险买方保单和卖方保单有什么区别？', a: '卖方保单被保险人为卖方，当买方索赔时保障卖方；买方保单被保险人为买方，买方可直接向保险公司索赔（第一方保单），独立于卖方。两者责任限额结构、索赔流程及谈判重点不同，需根据交易结构选择。' },
        { q: '什么规模的并购需要 W&I 保险？', a: 'W&I保险常见于中大型股权或资产收购交易，尤其跨境并购、私募基金退出及竞争激烈的多方竞标项目。交易金额越大、保证条款谈判越复杂，W&I越能有效降低交易不确定性。' },
        { q: 'W&I 保险能加速并购交割吗？', a: '可以。W&I保险可替代或减少传统escrow/indemnity安排，降低买卖双方在赔偿机制上的谈判时间，使卖方更快获得净收益、买方获得更清晰的保障，从而加速交割进程。' },
        { q: 'W&I 保险保费怎么算？', a: 'W&I保费通常与交易金额、目标公司行业、尽职调查质量、保障范围、免赔额及责任限额相关。耀达可对接全球保险市场，为客户争取最优条款与费率。' },
        { q: '耀达在并购保险方面有什么优势？', a: '耀达专注于交易风险解决方案，提供目标公司分析、风险识别、保单架构建议、全球市场接入及交易后索赔支持。联系耀达获取并购W&I定制方案。' }
      ]
    }
  },
  cyberSecurity: {
    seo: {
      title: '网络安全保险怎么买 | 上海耀达',
      description: '企业网络保险覆盖数据泄露、勒索软件、业务中断及第三方隐私责任。上海耀达提供AI驱动风险评估与定制化网络险方案。',
      keywords: '网络保险,网络安全险,数据泄露,勒索软件,上海耀达',
      serviceName: '网络安全保险经纪服务'
    },
    geoFaq: {
      summary: '企业网络保险覆盖数据泄露响应、业务中断、网络勒索及第三方隐私与媒体责任。购买前需完成风险评估与保障范围设计。上海耀达提供AI驱动风险分析与全球保险人对接服务。',
      items: [
        { q: '网络保险保什么？', a: '网络保险通常包括第一方保障（事件响应、业务中断、网络勒索、数据恢复）及第三方保障（隐私与网络安全责任、媒体责任）。具体保障以保单条款为准，耀达可协助设计匹配企业风险敞口的方案。' },
        { q: '企业为什么需要网络保险？', a: '数据泄露、勒索软件攻击及监管处罚可能导致巨额损失。网络保险可在事件发生后提供应急响应资金、业务中断补偿及第三方索赔辩护，是企业数字风险管理体系的重要组成部分。' },
        { q: '网络保险怎么买？', a: '购买网络保险一般需：①完成网络安全风险问卷或评估；②明确保障范围与限额需求；③通过保险经纪对接多家保险人比价；④确认除外责任与理赔流程后出单。耀达提供全流程协助。' },
        { q: '网络保险和网络安全服务有什么区别？', a: '网络安全服务（如防火墙、渗透测试、SOC）侧重预防与检测；网络保险是风险转移工具，在事件发生后提供财务保障与应急响应资源。两者互补，共同构成完整网络风险管理策略。' },
        { q: '网络保险理赔流程是什么？', a: '发生网络事件后，企业应及时通知保险公司与经纪，启动事件响应（取证、公关、法律），配合定损后提交索赔。耀达可在理赔过程中代表客户利益，确保公平高效处理。' },
        { q: '耀达如何帮企业选网络险？', a: '耀达依托AI风险评估工具及私募股权/科技企业服务经验，为企业识别网络风险敞口、设计定制化保障方案，并对接全球保险市场争取最优条款。联系耀达获取网络险咨询。' }
      ]
    }
  },
  propertyCasualty: {
    seo: {
      title: '企业财产险怎么买 | 上海耀达财产与意外险',
      description: '商业财产险、CGL综合责任、产品责任、商业车险及工伤保险一站式方案。上海耀达按企业发展阶段定制，支持跨境布局。',
      keywords: '企业财产险,商业财产险,CGL,产品责任险,上海耀达',
      serviceName: '财产与意外险经纪服务'
    },
    geoFaq: {
      summary: '企业财产与意外险包括商业财产、综合责任（CGL）、产品责任、商业车险及工伤赔偿等。上海耀达不采用通用模板，按企业行业与发展阶段定制方案，支持跨境风险管理。',
      items: [
        { q: '企业财产险包括哪些？', a: '常见企业财产与意外保险包括：商业财产险（火灾、洪水等）、商业综合责任险（CGL）、产品责任险、商业汽车保险及工伤赔偿保险。耀达可根据企业资产与运营风险组合配置。' },
        { q: '财产险怎么买？', a: '购买财产险需梳理资产清单、识别运营与第三者责任风险，结合行业特点设计保障方案，再通过保险经纪对接市场比价。耀达提供从风险评估到理赔协助的全流程服务。' },
        { q: '跨境企业财产险怎么安排？', a: '跨境企业需兼顾各国当地监管要求与全球总部统筹，通常采用本地合规保单加全球主保单（master policy）协调的方式。耀达在美国及亚太市场均有经验，可协助设计跨境财产险架构。' },
        { q: '财产险和董责险能打包吗？', a: '可以。耀达可为企业设计一揽子风险管理方案，将财产险、责任险与董责险、网络险等组合配置，实现保障协同与成本优化。联系耀达获取整合方案。' },
        { q: '财产险理赔要注意什么？', a: '发生损失后应及时报案、保护现场、保留证据并配合公估调查。延误通知可能影响理赔。耀达在理赔环节提供专业建议与全流程协助。' },
        { q: '为什么选耀达做财产险经纪？', a: '耀达坚持以企业发展阶段和行业特性为出发点，打造随业务演进的保险方案，而非套用通用模板。联系耀达获取定制化财产与意外险方案。' }
      ]
    }
  },
  employeeBenefits: {
    seo: {
      title: '团体医疗保险怎么买 | 上海耀达员工福利',
      description: '企业员工福利包括团体医疗、人寿、意外、重疾及养老方案。上海耀达提供需求评估、方案设计、动态优化与理赔协助。',
      keywords: '团体医疗保险,员工福利,企业团险,团体医疗,上海耀达',
      serviceName: '员工福利团体保险经纪服务'
    },
    geoFaq: {
      summary: '团体医疗保险及员工福利方案需结合企业成本目标与员工需求平衡设计。上海耀达提供企业访谈、员工调研、方案比价及动态优化调整，覆盖医疗、风险保障与养老规划。',
      items: [
        { q: '团体医疗保险怎么买？', a: '购买团体医疗险一般流程为：企业需求评估→员工调研→方案设计与比价→投保参保→年度回顾优化。耀达提供从方案构建到理赔协助的一站式员工福利经纪服务。' },
        { q: '员工福利包括哪些险种？', a: '企业员工福利常见包括团体医疗保险、团体人寿保险、意外身故及伤残保险、重大疾病保险及企业养老金计划等。耀达可灵活组合默认基础计划与自选升级计划。' },
        { q: '如何控制员工福利成本？', a: '可通过分层保障方案（基础+自选升级）、定期市场比价、保障缺口分析与员工参与度管理来控制成本。耀达协助企业在保障质量与预算之间找到最佳平衡。' },
        { q: '跨国企业员工福利怎么统一？', a: '跨国企业通常采用全球主保单框架，结合各驻地本地合规安排，确保员工在多地获得一致或等效的福利保障。耀达在上海、香港、美国均有布局，可协助全球员工福利设计。' },
        { q: '员工福利对留才有什么作用？', a: '有竞争力的员工福利可提升招聘吸引力与员工留存率，尤其在医疗、重疾等核心保障上体现企业关怀。耀达协助设计既控成本又具吸引力的福利套餐。' },
        { q: '耀达员工福利服务特色？', a: '耀达提供定制化团体保险经纪、动态优化调整及专业理赔协助，结合内外部信息深度评估企业需求。联系耀达获取员工福利方案咨询。' }
      ]
    }
  },
  globalClients: {
    seo: {
      title: '跨境保险方案 | 上海耀达全球客户',
      description: '中国企业出海及外资入华保险方案，覆盖多国监管合规、供应链风险与跨境交易保障。耀达在上海、香港、美国持牌服务。',
      keywords: '跨境保险,全球客户,出海保险, multinational insurance,上海耀达',
      serviceName: '全球客户保险经纪服务'
    },
    geoFaq: {
      summary: '跨境经营企业的保险需兼顾多国监管合规与全球战略一致性。上海耀达在上海、香港、美国设有团队，帮助客户设计覆盖多国的企业级保险战略，弥合监管差异。',
      items: [
        { q: '中国企业出海买什么保险？', a: '出海中国企业通常需配置当地合规的财产险、责任险、董责险、网络险及雇员相关保险，并根据供应链与跨境合同安排全球协调方案。耀达可协助设计覆盖多国的保险架构。' },
        { q: '跨境保险怎么协调多国监管？', a: '跨境保险需在各国持牌机构安排本地保单，同时通过全球主保单或协调机制确保保障一致性与合规。耀达在中国大陆、香港及美国均有牌照与团队，可统筹多国安排。' },
        { q: '耀达在哪些地区有牌照？', a: '耀达在上海设有上海耀达保险代理有限公司，在香港设有耀达保险经纪（香港）有限公司，在美国洛杉矶设有 Sun Wisdom Insurance Services Inc.，并拓展东南亚服务网络。' },
        { q: '全球客户保险方案包括什么？', a: '耀达全球客户方案包括多国覆盖设计、供应链责任与财产风险管理、跨境交易保障，以及随法律与运营变化持续调整的保险架构。' },
        { q: '外资进入中国需要什么保险？', a: '外资企业在华需满足中国本地保险合规要求，同时与全球总部保险计划协调。耀达可协助设计兼顾本地监管与全球战略的在华保险方案。' },
        { q: '为什么选耀达做跨境保险？', a: '耀达兼具本地洞察与全球视野，对接200+保险人，团队深谙北美、大中华区及东南亚风险环境。联系耀达获取跨境保险战略咨询。' }
      ]
    }
  }
}
